"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SelectFacet = void 0;

var _react = _interopRequireDefault(require("react"));

var _client = require("@searchkit/client");

var _reactI18next = require("react-i18next");

var _classnames = _interopRequireDefault(require("classnames"));

var _Select = _interopRequireDefault(require("../../../Form/Select"));

var _FormikWrapper = _interopRequireDefault(require("../../../Form/FormikWrapper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var useInitialValues = function useInitialValues() {
  var parsed = (0, _client.useSearchkitVariables)();
  var filters = {};

  if (parsed.filters) {
    parsed.filters.forEach(function (filter) {
      filters[filter.identifier] = filter.value;
    });
  }

  return filters;
};

var SelectFacet = function SelectFacet(_ref) {
  var facet = _ref.facet;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var api = (0, _client.useSearchkit)();
  var options = facet.entries.map(function (entry) {
    return {
      value: entry.label,
      label: facet.identifier === 'type' ? t("tags.".concat(entry.label.toLowerCase())) : entry.label,
      disabled: parseInt(entry.count) === 0
    };
  });
  var placeHolder = t("placeholders.".concat(facet.identifier, ".placeholder"));
  var classes = (0, _classnames.default)('Facet', 'SelectFacet', "Facet--".concat(facet.identifier));
  var initialValues = useInitialValues();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    key: facet.identifier
  }, /*#__PURE__*/_react.default.createElement(_FormikWrapper.default, {
    initialValues: initialValues
  }, /*#__PURE__*/_react.default.createElement(_Select.default, {
    title: facet.label,
    required: true,
    placeholder: placeHolder,
    fieldName: facet.identifier,
    options: options,
    isSearchable: facet.isSearchable,
    isClearable: facet.isClearable,
    onChange: function onChange(value) {
      api.removeFiltersByIdentifier(facet.identifier);
      api.setPage({
        from: 0
      });

      if (value) {
        api.addFilter({
          identifier: facet.identifier,
          value: value
        });
      }

      api.search();
    }
  })));
};

exports.SelectFacet = SelectFacet;
SelectFacet.DISPLAY = 'SelectFacet';
var _default = SelectFacet;
exports.default = _default;